import { useState, useEffect } from "react";
import TarifsDetails from "./tarifsDetails";
import TarifsSumery from "./tarifsSumery";

function TarifsResponsivSelector() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <TarifsSumery /> : <TarifsDetails />;
}

export default TarifsResponsivSelector;
